const AlertBanner = require('./modules/alert-banner.js');
new AlertBanner();
